module.exports = __webpack_public_path__ + "img/slide-2.d237cd99.jpg";